import { Search, Map, BarChart3, ArrowRight, Star } from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";

const Approach = () => {
  const { t, language } = useLanguage();
  
  const steps = [
    {
      icon: Search,
      title: "approach.step1.title",
      description: "approach.step1.desc",
      number: "01",
    },
    {
      icon: Map,
      title: "approach.step2.title",
      description: "approach.step2.desc",
      number: "02",
    },
    {
      icon: BarChart3,
      title: "approach.step3.title",
      description: "approach.step3.desc",
      number: "03",
    },
  ];

  return (
    <section id="approach" className="py-12 lg:py-16 relative overflow-hidden">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-8">
          <h2 className="text-2xl sm:text-3xl font-display font-bold text-slate-800 mb-2">
            {language === "fr" ? "Notre approche" : "Our approach"}
          </h2>
          <p className="text-slate-500 max-w-lg mx-auto text-sm">
            {t("approach.subtitle")}
          </p>
        </div>

        {/* Timeline horizontal */}
        <div className="relative">
          {/* Ligne de connexion en pointillés */}
          <div className="hidden md:block absolute top-8 left-[16.67%] right-[16.67%] h-0.5 border-t-2 border-dashed border-slate-300" />
          
          {/* Shooting star animation */}
          <div className="hidden md:block absolute top-8 left-[16.67%] right-[16.67%] h-0.5 overflow-visible">
            <div className="shooting-star absolute flex items-center">
              <Star className="w-3 h-3 text-amber-400 fill-amber-300 drop-shadow-[0_0_6px_rgba(251,191,36,1)]" />
              {/* Particles */}
              <span className="particle particle-1"></span>
              <span className="particle particle-2"></span>
              <span className="particle particle-3"></span>
              <span className="particle particle-4"></span>
              <span className="particle particle-5"></span>
            </div>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {steps.map((step, index) => (
              <div key={index} className="relative flex flex-col items-center text-center group">
                {/* Numéro avec cercle */}
                <div className={`relative z-10 w-16 h-16 rounded-full bg-white border-2 border-slate-200 flex items-center justify-center mb-4 shadow-lg group-hover:border-sky-400 group-hover:shadow-sky-200/50 transition-all duration-300 approach-number-${index + 1}`}>
                  <span className={`text-xl font-display font-bold bg-gradient-to-br from-sky-500 to-blue-600 bg-clip-text text-transparent approach-number-text-${index + 1}`}>
                    {step.number}
                  </span>
                </div>
                
                {/* Icône */}
                <div className="w-10 h-10 rounded-lg bg-slate-100 flex items-center justify-center mb-3 group-hover:bg-sky-50 transition-colors">
                  <step.icon className="h-5 w-5 text-slate-500 group-hover:text-sky-600 transition-colors" />
                </div>
                
                <h3 className="text-base font-display font-semibold text-slate-800 mb-2 group-hover:text-sky-600 transition-colors">
                  {t(step.title)}
                </h3>
                <p className="text-sm text-slate-500 leading-relaxed max-w-xs">
                  {t(step.description)}
                </p>
                
                {/* Flèche vers le suivant (mobile) */}
                {index < steps.length - 1 && (
                  <ArrowRight className="md:hidden w-5 h-5 text-slate-300 mt-4" />
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Approach;
